module.exports = {
          srcSet: __webpack_public_path__ + "7b9f82784db623df5fb95763fe7983e0-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "7b9f82784db623df5fb95763fe7983e0-180.png",width: 180,height: 26}],
          src: __webpack_public_path__ + "7b9f82784db623df5fb95763fe7983e0-180.png",
          toString:function(){return __webpack_public_path__ + "7b9f82784db623df5fb95763fe7983e0-180.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAABCAYAAADn9T9+AAAACXBIWXMAABYlAAAWJQFJUiTwAAAALElEQVR4nAXBsRGAIAAEMIr87+NKjEDhWVlYydYkA2+SGx9WktX2wo/dduI5YUkFAcay95kAAAAASUVORK5CYII=",
          width: 180,
          height: 26
        }